module.exports = __webpack_public_path__ + "img/login_bg_yunduan.f3268773.png";